import { getCampaignData } from './investment-process/useCampaign'
import { useInvestmentProcessDataState } from './investment-process/useInvestmentProcess'

export function trackAnalyticsInvestmentProcessStep1() {
    trackGoogleTagManagerEvent({
        event: 'investmentProcess',
        virtualPageURL: '' + window.location + 'step1',
        virtualPageTitle: getCampaignData().asset_data.asset_title + ' - Step 1',
        pageCategory: 'investment process',
        ecommerce: {
            currencyCode: getCampaignCurrencyCode(),
            checkout: {
                actionField: { step: 1 },
                products: [
                    {
                        name: getCampaignData().asset_data.asset_title, // name of project
                        id: getCampaignData().asset_data.asset_var_uid, // Projekt ID
                        price: '' + getCampaignData().asset_data.investment_min + '', // investment amount
                        quantity: 1,
                    },
                ],
            },
        },
    })

    trackJentisEvent({
        track: 'product',
        type: 'addtocart',
        id: getCampaignData().asset_data.asset_var_uid,
        name: getCampaignData().asset_data.asset_title,
        quantity: 1,
        brutto: getCampaignData().asset_data.investment_min,
        currency: getCampaignCurrencyCode(),
    })

    trackJentisEvent({
        track: 'addtocart',
        step: 1,
        brutto: getCampaignData().asset_data.investment_min,
        shipping: 0,
        tax: 0,
    })

    sumbitJentisEvents()
}

export function trackAnalyticsInvestmentProcessStep2() {
    trackGoogleTagManagerEvent({
        event: 'investmentProcess',
        virtualPageURL: '' + window.location + 'step2',
        virtualPageTitle: getCampaignData().asset_data.asset_title + ' - Step 2',
        pageCategory: 'investment process',
        ecommerce: {
            currencyCode: getCampaignCurrencyCode(),
            checkout: {
                actionField: { step: 2 },
                products: [
                    {
                        name: getCampaignData().asset_data.asset_title, // name of project
                        id: getCampaignData().asset_data.asset_var_uid, // Projekt ID
                        price: '' + useInvestmentProcessDataState().investmentAmount + '', // investment amount
                        quantity: 1,
                    },
                ],
            },
        },
    })
    trackJentisEvent({
        track: 'product',
        type: 'checkout',
        id: getCampaignData().asset_data.asset_var_uid,
        name: getCampaignData().asset_data.asset_title,
        quantity: 1,
        brutto: useInvestmentProcessDataState().investmentAmount,
        currency: getCampaignCurrencyCode(),
    })

    trackJentisEvent({
        track: 'checkout',
        step: 2,
        shipping: 0,
        brutto: useInvestmentProcessDataState().investmentAmount,
        tax: 0,
    })

    sumbitJentisEvents()
}

export function trackAnalyticsInvestmentProcessStep3() {
    trackGoogleTagManagerEvent({
        event: 'investmentProcess',
        virtualPageURL: '' + window.location + 'step3',
        virtualPageTitle: getCampaignData().asset_data.asset_title + ' - Step 3',
        pageCategory: 'investment process',
        ecommerce: {
            currencyCode: getCampaignCurrencyCode(),
            checkout: {
                actionField: { step: 3 },
                products: [
                    {
                        name: getCampaignData().asset_data.asset_title, // name of project
                        id: getCampaignData().asset_data.asset_var_uid, // Projekt ID
                        price: '' + useInvestmentProcessDataState().investmentAmount + '', // investment amount
                        quantity: 1,
                    },
                ],
            },
        },
    })

    trackJentisEvent({
        track: 'product',
        type: 'checkout',
        id: getCampaignData().asset_data.asset_var_uid,
        name: getCampaignData().asset_data.asset_title,
        quantity: 1,
        brutto: useInvestmentProcessDataState().investmentAmount,
        currency: getCampaignCurrencyCode(),
    })

    trackJentisEvent({
        track: 'checkout',
        step: 3,
        shipping: 0,
        brutto: useInvestmentProcessDataState().investmentAmount,
        tax: 0,
    })

    sumbitJentisEvents()
}

export function trackAnalyticsInvestmentProcessStep4() {
    trackGoogleTagManagerEvent({
        event: 'investmentProcess',
        virtualPageURL: '' + window.location + 'step4',
        virtualPageTitle: getCampaignData().asset_data.asset_title + ' - Step 4',
        pageCategory: 'investment process',
        ecommerce: {
            currencyCode: getCampaignCurrencyCode(),
            purchase: {
                actionField: {
                    id: useInvestmentProcessDataState().createdOrder.order_uid, // Transaction ID
                    affiliation: useInvestmentProcessDataState().createdOrder.platform_name, // name of plattform
                    revenue: useInvestmentProcessDataState().createdOrder.total_amount,
                    tax: '0.00',
                    shipping: '0.00',
                    coupon: '',
                },
                products: [
                    {
                        name: useInvestmentProcessDataState().createdOrder.asset_data.asset_title, // name of project
                        id: useInvestmentProcessDataState().createdOrder.asset_var_uid, // Projekt ID
                        price: useInvestmentProcessDataState().createdOrder.total_amount, // investment amount
                        quantity: 1,
                    },
                ],
            },
        },
    })

    trackJentisEvent({
        track: 'product',
        type: 'order',
        id: useInvestmentProcessDataState().createdOrder.asset_var_uid,
        name: useInvestmentProcessDataState().createdOrder.asset_data.asset_title,
        brutto: useInvestmentProcessDataState().createdOrder.total_amount,
        quantity: 1,
        currency: getCampaignCurrencyCode(),
    })

    trackJentisEvent({
        track: 'order',
        orderid: useInvestmentProcessDataState().createdOrder.order_uid,
        brutto: useInvestmentProcessDataState().createdOrder.total_amount,
        tax: 0,
        shipping: 0,
        affiliation: useInvestmentProcessDataState().createdOrder.platform_name,
    })

    sumbitJentisEvents()
}

export function trackGoogleTagManagerEvent(payload: any) {
    if (
        window.BorlabsCookie &&
        !(
            window.BorlabsCookie.Consents.hasConsent('google-analytics') ||
            window.BorlabsCookie.Consents.hasConsent('google-analytics-statistics')
        )
    ) {
        return
    }
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
}

export function trackJentisEvent(payload: any) {
    if (window._jts) {
        window._jts.push(payload)
    }
}

export function sumbitJentisEvents() {
    if (window._jts) {
        window._jts.push({
            track: 'submit',
        })
    }
}

export function getCampaignCurrencyCode() {
    if (getCampaignData().asset_data.currency === '&euro;') {
        return 'EUR'
    } else {
        return getCampaignData().asset_data.currency
    }
}
